export const tr = {
    notifications: 'Bildirimler'
};
